<template>
  <w-modal v-model="open" type="danger">
    <h1 slot="header">{{ setting.title }}</h1>
    <div slot="content" class="content">
      <p>
        <span class="icon-alert-circle" /> {{ setting.description }}
      </p>
    </div>
    <div slot="footer">
      <w-button
        type="link"
        color-type="error"
        :disabled="loading"
        @click="open = false"
      >
        取消
      </w-button>
      <w-button
        class="ml-2"
        color-type="error"
        :disabled="loading"
        @click="onConfirm"
      >
        {{ loading ? setting.confirmLoading : setting.confirmText }}
      </w-button>
    </div>
  </w-modal>
</template>

<script>
import ScheduleActionModal from './ScheduleActionModal';

export default ScheduleActionModal;
</script>

<style lang="scss" scoped>
@import 'ScheduleActionModal';
</style>
